import { LoadingModal } from 'components/response/LoadingModal';
import { QuotationSingleForm } from 'components/single-form-view/quotation/QuotationSingleForm';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import { LOAN_ACTIONS } from 'constants/LoanActions';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR } from 'constants/ResponseType';
import { FormContext } from 'context/FormContext';
import { useLoanFormContainerControl } from 'hooks/useLoanFormContainerControl';
import { useLogin } from 'hooks/useLogin';
import { ActionButtonConfig } from 'models/ActionButtonConfig';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { SingleFormContainer } from 'components/single-form/SingleFormContainer';
import { useQuotationServices } from 'hooks/useQuotationServices';
import { useFormData } from 'hooks/useFormData';
import { useControlModal } from 'hooks/useControlModal';
import { InfoModal } from 'components/modals/InfoModal';
import CHECK_OK from '../assets/icons/check_ok.svg'

const config = [
	{
		buttonBackName: 'Volver',
		buttonNextName: 'Continuar',
		backAction: LOAN_ACTIONS.BACK_TO_HOME,
		nextAction: LOAN_ACTIONS.UPDATE_FORM_WITH_SCORING_AND_FINISH,
	},
];

export const QuotationSimpleFormContainer = () => {
	const history = useHistory();
	const [login] = useLogin();
	const [utmSource, setutmSource] = useState("");
	const [formData, setformData] = useState({});
	const [idVehiculo, setIdVehiculo] = useState('');
	const [quotationUUID, setQuotationUUID] = useState('');
	const { createQuotation } = useQuotationServices();
	const { formatFormData} = useFormData();
	const { open, toggle } = useControlModal(false);
	const {
		executeAction,
		step,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
	} = useLoanFormContainerControl(
		DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_RECHAZO_KO,
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_SCORING_RECHAZO,
		DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_SOLICITUD_ENVIADA
	);

	const configAction: ActionButtonConfig[] = config.map((values) => {
		return {
			buttonBackName: values.buttonBackName,
			buttonNextName: values.buttonNextName,
			buttonBackClick: () => {
				executeAction(values.backAction, { ...formData, flow: 'NORMAL', trafficSources: sessionStorage.getItem('trafficSources') });
			},
			buttonNextClick: () => {
				setShowLoadingModal(true);
				createQuotation(formatFormData({
					"nombreCompleto":(formData as any).nombreCompleto,
					"rut":(formData as any).rut,
					"correo": (formData as any).correo,
					"telefono": (formData as any).telefono,
					"idVehiculo": idVehiculo
				}), (response: string) => {
					setQuotationUUID(response);
					toggle();
					setShowLoadingModal(false);
				});
			},
		} as ActionButtonConfig;
	});

	useEffect(
		() => {
			console.log('UTM Source:', utmSource);
			setShowLoadingModal(true);
			login(
				() => {
					const urlSearchParams = new URLSearchParams(window.location.search);
					const utmSource = urlSearchParams.get('utm_source');
					if (utmSource) {
						setutmSource(utmSource);
					}
					console.log(utmSource);
					setShowLoadingModal(false);
				},
				() => history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`),
			);
		},
		//eslint-disable-next-line
		[]
	);

	const setData = useCallback((data) => {
		setformData(data);
	}, []);

	const setIdVehiculos = useCallback((id) => {
		setIdVehiculo(id);
	}, []);

	return (
		<>
			{open ? (
				<InfoModal
					dataLayerKey={DATA_LAYER_RESPONSE_KEY.QUOTATION_FORM}
					open={open}
					title="Haz logrado hacer una cotización!!!"
					content={<>
						<img style={{ marginLeft: '40%' }} src={CHECK_OK} alt="" ></img>
						<div style={{ textAlign: 'center' }}>
							<h2>Acercate a nuestra oficina con este código</h2>
							<p>{quotationUUID}</p>
						</div>
					</>}
					buttonLabel="Entendido"
					toggleModal={()=>{
						toggle();
						history.push('')
					}}
				/>
			) : null}
			<FormContext.Provider
				value={{
					setError: setEnableButton,
					setData: setformData,
					//storage: storageService,
				}}
			>
				<LoadingModal showLoadingModal={showLoadingModal} />

				<SingleFormContainer
					controlConfig={configAction}
					view={<QuotationSingleForm dataLayerKey={DATA_LAYER_RESPONSE_KEY.QUOTATION_FORM} formData={formData} setData={setData} setIdVehiculo={setIdVehiculos}/>}
					currentStep={step}
					isError={enableButton}
				/>
			</FormContext.Provider>
		</>
	);
};
